import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-order-posted-tags-form',
  templateUrl: './order-posted-tags-form.component.html',
  styleUrls: ['./order-posted-tags-form.component.scss'],
})
export class OrderPostedTagsFormComponent implements OnInit {
  tags :number[] = [];

  constructor(
    public dialogRef :MatDialogRef<OrderPostedTagsFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      selected ?:number[];
      options ?:{ disallowEmpty ?:boolean };
    },
  ) {}

  ngOnInit() :void {
    this.data.options = Object.assign(
      {
        // DEFAULTS
        disallowEmpty: false,
      },
      this.data?.options,
    );
  }

  onSelectTags({ tag } :{ tag :number[] }) :void {
    this.tags = tag;
  }

  onSaveTags() :void {
    this.dialogRef.close(this.tags);
  }
}
